export function scrollToTop() {
  if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
}

export function scrollToElement(el, offset = -100) {
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset, immediate: true });
  else el.scrollIntoView({ block: "start" });
}
